var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 2C10.2736 2 12.6668 4.39249 12.667 7.33301C12.667 8.56365 12.243 9.695 11.541 10.5977L13.8047 12.8623C14.0652 13.123 14.0653 13.5441 13.8047 13.8047C13.6747 13.9347 13.5037 14 13.333 14C13.1625 13.9999 12.9922 13.9345 12.8623 13.8047L10.5977 11.541C9.695 12.243 8.56365 12.667 7.33301 12.667C4.39249 12.6668 2 10.2736 2 7.33301C2.00018 4.3926 4.3926 2.00018 7.33301 2ZM7.33301 3.33301C5.12727 3.33318 3.33318 5.12727 3.33301 7.33301C3.33301 9.5389 5.12716 11.3328 7.33301 11.333C9.53901 11.333 11.333 9.53901 11.333 7.33301C11.3328 5.12716 9.5389 3.33301 7.33301 3.33301Z",
    fill: "#0E031D",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6203_2250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 13,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 2C10.2736 2 12.6668 4.39249 12.667 7.33301C12.667 8.56365 12.243 9.695 11.541 10.5977L13.8047 12.8623C14.0652 13.123 14.0653 13.5441 13.8047 13.8047C13.6747 13.9347 13.5037 14 13.333 14C13.1625 13.9999 12.9922 13.9345 12.8623 13.8047L10.5977 11.541C9.695 12.243 8.56365 12.667 7.33301 12.667C4.39249 12.6668 2 10.2736 2 7.33301C2.00018 4.3926 4.3926 2.00018 7.33301 2ZM7.33301 3.33301C5.12727 3.33318 3.33318 5.12727 3.33301 7.33301C3.33301 9.5389 5.12716 11.3328 7.33301 11.333C9.53901 11.333 11.333 9.53901 11.333 7.33301C11.3328 5.12716 9.5389 3.33301 7.33301 3.33301Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6203_2250)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilled);
export default __webpack_public_path__ + "static/media/search-filled.da188bb0f75eada37649e984a636520e.svg";
export { ForwardRef as ReactComponent };